import { Recommendation as _Recommendation } from './fetchRecommendations'
export { default, formatRecommendations } from './fetchRecommendations'
export type Recommendation = _Recommendation
